import { Link } from "react-router-dom";
import SubscribeForm from "@/components/feature/SubscribeForm";

export default function CtaBand() {
  return (
    <section aria-labelledby="cta-title" className="w-full px-4 md:px-6 pb-4">
      <div className="rounded-lg bg-background-100 border border-background-200 p-6 md:p-10 grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12">
        <div>
          <p className="text-xs font-medium tracking-widest text-primary-600 uppercase">参与进来</p>
          <h2 id="cta-title" className="mt-2 text-2xl md:text-3xl font-bold text-foreground-950 leading-snug">
            你拍到的那一幕，可能正是别人需要的线索
          </h2>
          <p className="mt-4 text-sm md:text-base text-foreground-600 leading-relaxed">
            投稿不需要文采，也不需要实名。把时间、地点和过程说清楚，剩下的交给编辑部来整理。
            如果只是想安静围观，订阅每周汇总也完全够用。
          </p>
          <div className="mt-6 flex flex-wrap gap-3">
            <Link
              to="/submit"
              className="inline-flex items-center gap-2 px-5 py-3 rounded-md bg-primary-500 text-background-50 text-sm whitespace-nowrap hover:bg-primary-600 transition-colors"
            >
              <i className="ri-send-plane-fill" aria-hidden="true" />
              我要投稿
            </Link>
            <Link
              to="/about"
              className="inline-flex items-center gap-2 px-5 py-3 rounded-md border border-background-300 text-foreground-800 text-sm whitespace-nowrap hover:bg-background-200 transition-colors"
            >
              了解内容原则
            </Link>
          </div>
        </div>

        <div className="flex flex-col justify-center">
          <h3 className="text-base font-bold text-foreground-900">订阅每周线索汇总</h3>
          <p className="mt-1.5 mb-4 text-sm text-foreground-600">
            每周一封，只放编辑部认为值得读完的条目，不含广告。
          </p>
          <SubscribeForm />
        </div>
      </div>
    </section>
  );
}